import useId from "hooks/useId";
import React, { ComponentProps } from "react";
import { ChangeEvent } from "react";
import { FormCheck } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  inputClassName?: string;
  labelClassName?: string;
} & Omit<ComponentProps<typeof FormCheck>, "custom" | "type" | "id">;

const RadioButton = ({
  className,
  label = " ",
  inputClassName,
  labelClassName,
  "aria-label": ariaLabel,
  ...props
}: Props) => {
  const id = useId("radio");

  return (
    <div
      className={getClasses(
        "custom-control custom-radio",
        styles["radio"],
        className,
      )}
    >
      <input
        id={id}
        aria-label={ariaLabel}
        type="radio"
        name="radio"
        className={getClasses("custom-control-input", inputClassName)}
        {...props}
      />
      <label
        htmlFor={id}
        className={getClasses("custom-control-label", labelClassName)}
      >
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
